import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Grid,
  Button,
  Divider,
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

import { useToast } from "../components/ToastContext";
import 'react-toastify/dist/ReactToastify.css';
import {api}from '../services/api';
import Layout from "../layout/layout";

const AddDiscount = () => {
  const theme = useTheme();
   const toast = useToast();
  const navigate = useNavigate();
  const [cloudProviders, setCloudProviders] = useState([]);
  const [clients, setClients] = useState([]);
  const [formData, setFormData] = useState({
    discountPercentage: '',
    cloudProvider: '',
    clientId: '',
    userId: sessionStorage.getItem('userId'), // Retrieve userId from localStorage
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCloudProviders = async () => {
      try {
        const response = await api.get('/Client/cloudProviders');
        setCloudProviders(response.data);
      } catch (error) {
        console.error("Error fetching cloud providers:", error);
      }
    };

    const fetchClients = async () => {
      const userId = formData.userId; // Obtain userId from formData
      try {
        const response = await api.get(`/Client/GetOrganizationDetailsByUserId/${userId}`);
        setClients(response.data);
      } catch (error) {
        console.error("Error fetching clients:", error);
      }
    };

    fetchCloudProviders();
    fetchClients();
  }, [formData.userId]); // Dependency array includes userId

  const handleSubmit = async () => {
    if (!formData.discountPercentage) {
      toast.error("Discount Percentage is required.");
      return;
    }

    if (!formData.cloudProvider) {
      toast.error("Cloud Provider is required.");
      return;
    }

    if (!formData.clientId) {
      toast.error("Client is required.");
      return;
    }

    const discountData = {
      cloudProvider: formData.cloudProvider,
      userId: formData.userId,
      // clientId: formData.clientId,
      OrganizationId: formData.clientId,
      discountPercentage: Number.parseFloat(formData.discountPercentage),
    };

    try {
      setLoading(true);
      const response = await api.post('/Project/discount', discountData, {
        headers: {
          'X-CORRELATION-ID': 'e7707845-953b-4baa-8dea-260aa7dfc8f9',
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        toast.success("Discount added successfully!");
        navigate('/Discount');
      }
    } catch (error) {
      console.error("Error adding discount:", error);
      toast.error("Failed to add discount.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout pageType='sideBar'>
      <Box sx={{ flex: 1, pl: theme.spacing(2), bgcolor: theme.palette.background.default, color: theme.palette.text.primary }}>
        <Divider />
        <Grid item xs={12} md={6} sx={{ width: '100%' }}>
          <Paper sx={{ p: theme.spacing(3), bgcolor: theme.palette.background.default, height: '100%', mt: theme.spacing(2) }}>
            <Box sx={{ borderBottom: `2px solid ${theme.palette.primary.main}`, px: theme.spacing(2), display: 'inline-block', mb: theme.spacing(2) }}>
              <Typography variant="body2" gutterBottom sx={{ display: 'inline-block', color: theme.palette.text.primary }}>
                Add Discount
              </Typography>
            </Box>

            <FormControl fullWidth sx={{ mt: theme.spacing(2) }}>
              <InputLabel sx={{ color: theme.palette.text.primary, fontSize: theme.typography.body2.fontSize }}>Cloud Provider</InputLabel>
              <Select
                value={formData.cloudProvider}
                onChange={(e) => setFormData((prevData) => ({ ...prevData, cloudProvider: e.target.value }))}
                label="Cloud Provider"
                sx={{ color: theme.palette.text.primary, fontSize: theme.typography.body2.fontSize }}
              >
                <MenuItem value="">-</MenuItem>
                {cloudProviders.map((provider) => (
                  <MenuItem key={provider.value} value={provider.value}>
                    {provider.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ mt: theme.spacing(2) }}>
              <InputLabel sx={{ color: theme.palette.text.primary, fontSize: theme.typography.body2.fontSize }}>Client</InputLabel>
              <Select
                value={formData.clientId}
                onChange={(e) => setFormData((prevData) => ({ ...prevData, clientId: e.target.value }))}
                label="Client"
                sx={{ color: theme.palette.text.primary, fontSize: theme.typography.body2.fontSize }}
              >
                <MenuItem value="">-</MenuItem>
                {clients.map((client) => (
                  <MenuItem key={client.clientId} value={client.clientId}>
                    {client.clientName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              fullWidth
              variant="outlined"
              placeholder="Discount Percentage"
              type="number"
              slotProps={{
  htmlInput: {
    step: "0.01", // Allows for decimal values
    min: "0",     // Optional: set a minimum value
    max: "100"    // Optional: set a maximum value
  }
}}
              value={formData.discountPercentage}
              onChange={(e) => setFormData((prevData) => ({ ...prevData, discountPercentage: e.target.value }))}
              sx={{ input: { color: theme.palette.text.primary, fontSize: theme.typography.body2.fontSize }, mt: theme.spacing(2) }}
            />

            <Box sx={{ display: 'flex', mt: theme.spacing(2), justifyContent: 'space-between' }}>
              <Button
                variant="cancelContained"
                // sx={{
                //   borderColor: theme.palette.primary.main,
                //   '&:hover': {
                //     borderColor: '#17a2fb',
                //   },
                // }}
                onClick={() => navigate('/Discount')}
              >
                Cancel
              </Button>
              <Button
                variant="greenContained"
                // sx={{
                //   backgroundColor: theme.palette.customColors.green,
                //   '&:hover': {
                //     backgroundColor: '#43a047',
                //   },
                // }}
                onClick={() => handleSubmit()}
              >
                Save
              </Button>
              
            </Box>
          </Paper>
        </Grid>
      </Box>
      
    </Layout>
  );
}

export default AddDiscount;

